import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/local-ai`;

const http = axios.create({ baseURL: API });

export async function getStatus() {
  const { data } = await http.get("/status");
  return data;
}

export async function getModels() {
  const { data } = await http.get("/models");
  return data;
}

export async function sendChat(payload) {
  const { data } = await http.post("/chat", payload);
  return data;
}

export async function sendVision(payload) {
  const { data } = await http.post("/vision", payload);
  return data;
}

export async function getConfig() {
  const { data } = await http.get("/config");
  return data;
}

export async function saveConfig(payload) {
  const { data } = await http.put("/config", payload);
  return data;
}

const savedRepos = axios.create({ baseURL: `${BACKEND_URL}/api/saved-repos` });

export async function listSavedRepos() {
  const { data } = await savedRepos.get("");
  return data.items || [];
}

export async function saveRepo(payload) {
  const { data } = await savedRepos.post("", payload);
  return data;
}

export async function deleteSavedRepo(url) {
  await savedRepos.delete("", { params: { url } });
}
